var map = {
	"./Lato-Black.ttf": 6741,
	"./Lato-Bold.ttf": 2181,
	"./Lato-BoldItalic.ttf": 2235,
	"./Lato-Italic.ttf": 7766,
	"./Lato-Light.ttf": 933,
	"./Lato-LightItalic.ttf": 9844,
	"./Lato-Regular.ttf": 4915,
	"./Lato-Thin.ttf": 119,
	"./Lato-ThinItalic.ttf": 1826,
	"fonts/Lato-Black.ttf": 6741,
	"fonts/Lato-Bold.ttf": 2181,
	"fonts/Lato-BoldItalic.ttf": 2235,
	"fonts/Lato-Italic.ttf": 7766,
	"fonts/Lato-Light.ttf": 933,
	"fonts/Lato-LightItalic.ttf": 9844,
	"fonts/Lato-Regular.ttf": 4915,
	"fonts/Lato-Thin.ttf": 119,
	"fonts/Lato-ThinItalic.ttf": 1826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9582;